import { IPackageProduct } from '../../../cart/core/interfaces/IPackageProduct';
import { IKioskPackage, IKioskPackageContent } from '../../core/interfaces/IKioskPackage';

export interface IPackageContentGroup {
  groupingNr: number;
  contents: IKioskPackageContent[];
}

export function buildPackageContentGroups(pkg: IKioskPackage): IPackageContentGroup[] {
  const groups: IPackageContentGroup[] = [];

  pkg.packageContent.forEach(content => {
    const group = groups.find(x => x.groupingNr === content.groupingNr);

    if (group) {
      group.contents.push(content);
    } else {
      groups.push({
        groupingNr: content.groupingNr,
        contents: [content]
      });
    }
  });

  return groups;
}

export function resolveFixedPackageLeaves(
  pkg: IKioskPackage,
  depth: number,
  maxDepth: number
): IPackageProduct[] | null {
  if (depth > maxDepth) {
    return null;
  }

  const groups = buildPackageContentGroups(pkg);
  const needsChoice = !(
    groups.every(group => group.contents.length === 1) ||
    (groups.length === 1 && groups[0].groupingNr === undefined)
  );

  if (needsChoice) {
    return null;
  }

  const leaves: IPackageProduct[] = [];

  for (const group of groups) {
    for (const content of group.contents) {
      if (content.contentPackage) {
        const nestedLeaves = resolveFixedPackageLeaves(content.contentPackage, depth + 1, maxDepth);
        if (!nestedLeaves) {
          return null;
        }
        leaves.push(...nestedLeaves);
      } else if (content.product) {
        leaves.push({
          id: content.product.id,
          name: content.product.name,
          groupingNr: group.groupingNr
        });
      } else {
        return null;
      }
    }
  }

  return leaves;
}
